import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';


const BASE_URL = ConfigurationService.get(ConfigurationKeys.BASE_URL);

export const EDITPROFILE_URL = `${BASE_URL}/rest/v1.0/profile/{userName}/info`;
export const COUNTRIES_URL = `${BASE_URL}/rest/v1.0/blockedCountries/{username}`;
export const USER_GET_CONSENTS_URL = `${BASE_URL}/rest/v1.0/user/{username}/consent/all`;
export const USER_POST_CONSENT_URL = `${BASE_URL}/rest/v1.0/user/{username}/consent`;
